import { useTenantsControllerListTenantsSuspense } from "@/api/orval/connect";

/**
 * テナント一覧。
 *
 * API はホスト限定で、admin / member が呼ぶと 403。呼び出し側でロールを絞る。
 */
export const useGetTenants = () => {
  const { data } = useTenantsControllerListTenantsSuspense();

  return { tenants: data.tenants };
};
